/**
 * The one product search — client limits (XWP-12 / refonte WP-37). Build-time values that mirror the
 * server's clamp (apps/server/src/config/moteur-recherche.config.js RECHERCHE_PRODUIT: default 15,
 * clamped to 50 — DECISIONS A-43); the client never asks more than the server serves.
 */

/** Rows of a counter picker (Caisse libre, Vente CHIFA, Instance CHIFA, échange, retour). */
export const RECHERCHE_POS_LIMITE = 15;

/** Rows of a catalogue picker outside the counters (achat urgent, appel d'offres…). */
export const RECHERCHE_CATALOGUE_LIMITE = 15;
